import SoftSignalsLockedHint from './SoftSignalsLockedHint.component';

export default SoftSignalsLockedHint;
